<template>
	<div class="container">
		<div class="row">
			<div class="form-container forgot-password-form">
				<h2 class="title-center header-no-padding-bottom">Recuperación de contraseña</h2>
				<div class="col-sm-6 col-sm-offset-3">
					<form class="form-horizontal" role="form" novalidate @submit="ForgotPassword">
						<div class="form-group">
							<p class="col-sm-9 col-sm-offset-3">¿Olvidó su contraseña?<br><br>
							Introduce tu correo electrónico y recibirás instrucciones para recuperar tu contraseña
							</p>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="email">Email</label>
							<div class="col-sm-9">
							  <input type="email" class="form-control" :class="{ 'has-error': err.email }" id="email" v-model="form.email">
							</div>
							<div class="tooltip-error" v-if="err.email">
						      	<span><i class="fa fa-play fa-rotate-180"></i></span>
						      	Ingresa tu email para continuar.
				      		</div>
				      		<div class="tooltip-error" v-if="err.email_regex">
						      	<span><i class="fa fa-play fa-rotate-180"></i></span>
						      	{{ error_msg }}
				      		</div>
						</div>
						<div class="form-group"> 
						    <div class="col-sm-offset-3 col-sm-9">
						      <button type="submit" class="btn btn-black btn-lg">Enviar</button>
						    </div>
					    </div>
					    <div class="col-sm-offset-3 col-sm-9 text-center">
							<a v-link="{path: '/login'}">Iniciar sesión</a><br>
							<a v-link="{path: '/registro'}">Registrarse</a><br>
					    </div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var email_regexp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
import API from '../store/api';

var form = {
	email: ''
};

export default{
	// ---- DATA ----

	data() {
		return {
			form: form,
			has_error: false,
			error_msg: '',
			err: {}
		};
	},

	// ---- METHODS ----

	methods: {
		ForgotPassword(e) {
			e.preventDefault();
			this.has_error = false;
			this.error_msg = '';
			this.err = {};

			this.validateEmail();

			$(window).resize( function(){
				if ($(window).width()<778){
					setTimeout( function(){
						$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
						$(".top-caret").css({"display": "none"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}else{
					setTimeout( function(){
						$(".tooltip-error").css({"position": "absolute", "margin-top" : "0"});
						$(".top-caret").css({"display": "block"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}
			});
			
			if (this.has_error) {
				return;
			}

			API.Users.forgotPass(this.form);
			// e.target.reset();
		},

		validateEmail() {
			for (var k in this.form) {
				if (!this.form[k]) {
					this.has_error = true;
					this.err[k] = true;
				}
			}

			if (this.has_error) {
				return;
			}

			if (!this.form.email.match(email_regexp)) {
				this.error_msg = 'Ingresa un correo electrónico válido';
				this.err.email_regex = true;
				this.has_error = true;
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// Forgot-password.vue?1239e7b5